import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, Optional } from "@angular/core";
import { FormControl } from "@angular/forms";
import { VngDialogService, VngDialogRef, VNG_DIALOG_DATA, VngTourService } from "@vengreso/angular-components";
import { Observable, Subscription, lastValueFrom, of } from "rxjs";
import { catchError, debounceTime, distinctUntilChanged, finalize, map, switchMap, tap } from "rxjs/operators";
import { DataService } from "src/app/core/core-services/services/dataservices/data.service";
import { AdvancedSearchDialogComponent } from "../advanced-search-dialog/advanced-search-dialog.component";

import { Location } from "@angular/common";
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router } from "@angular/router";
import { AuthService } from "../../core-services/services/auth.service";
import { SharedDataService } from "../../core-services/services/shared-data.service";
import { GlobalHookService } from "src/app/global-hook.service";
import { OnboardingProgressService } from "src/app/core/core-services/services/onboarding-progress.service";
@Component({
    selector: "app-top-search-bar",
    templateUrl: "./top-search-bar.component.html",
    styleUrls: ["./top-search-bar.component.scss"],
    standalone: false
})
export class TopSearchBarComponent implements OnInit, OnDestroy {
  public isLoading = false;
  public src: string;
  public myControl = new FormControl();
  filteredOptions: Observable<any>;
  advancedSearch = false;
  currentDialog: any;
  flycut: string;
  title: string;
  hasTheWords: string;
  doesntHave: string;
  createdWithin: string;
  minDate: any;
  maxDate: any;
  bySearch: string;
  hasAttachment: boolean;
  hasHyperlink: boolean;
  date: string;
  show: any;
  progressValue = 0;
  // Initialized to today
  model: any = { jsdate: new Date() };
  progresshow = false;

  currentUrl: string;
  private readonly subscriptions: Subscription[] = [];

  /**
   * Issue #537: replaces the legacy `onboardingv2_completed`-driven getter.
   * Kept as a live-subscribed field (not a getter re-read on every change
   * detection) so the glow is guaranteed to drop the instant the 3rd
   * required step completes, matching how `progressValue` (above) is kept
   * live off `percentage$` — see the constructor subscription below.
   */
  firstThreeComplete = false;

  /** Issue #537: guards teardownOnboardingReentryTooltip() so it's a no-op when the re-entry tooltip isn't the one currently showing (e.g. the learning-resources tooltip is). Set the instant the tooltip is scheduled — NOT the same as "on screen"; see reentryTooltipStarted below. */
  private reentryTooltipActive = false;
  /**
   * Issue #537 (QA F-1): true only once tourService.start() has actually
   * been called for the re-entry tooltip. VngTourService.end() on a tour
   * that was never start()ed is a no-op — it never fires end$ — so
   * teardownOnboardingReentryTooltip() branches on this flag instead of
   * relying on that round-trip: tearing down a not-yet-started tooltip is
   * handled synchronously (below) rather than via the end$ subscription.
   */
  private reentryTooltipStarted = false;
  /** Issue #537 (QA F-1): handle of the pending `setTimeout` that calls tourService.start(); MUST be cancelled on teardown/destroy, or a torn-down tooltip still renders later (on top of whatever opened in the meantime — e.g. the walk-me modal). */
  private reentryTooltipStartTimer: ReturnType<typeof setTimeout> | null = null;
  /** Issue #537: set right before this component itself calls tourService.end() on an ALREADY-STARTED re-entry tooltip (modal opened, or the learning-resources tooltip is about to take over the hat) — read once by the end$ handler so THAT teardown never counts as an explicit dismissal. */
  private reentryTooltipTeardownProgrammatic = false;
  /** Issue #537 (QA F-1): the end$ subscription for the CURRENT re-entry tooltip instance, so a not-yet-started teardown can unsubscribe it directly instead of waiting on end$ (which won't fire). */
  private reentryTooltipEndSub: Subscription | null = null;

  constructor(
    private readonly dataService: DataService,
    private readonly dialog: VngDialogService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly sharedData: SharedDataService,
    private readonly globalHookService: GlobalHookService,
    private readonly host: ElementRef<HTMLElement>,
    private readonly location: Location,
    private readonly tourService: VngTourService,
    private readonly onboardingProgress: OnboardingProgressService,
    @Optional() @Inject(VNG_DIALOG_DATA) public mydata: any
  ) {
    //PROGRESS BAR SHOULD BE SHOWED FOR ALL USERS
    this.progresshow = true;

    // FIXED (#523): used to be a one-time read of `onboarding_percentage`
    // here in the constructor, so it went stale the moment a checklist step
    // completed elsewhere without a full page reload. Subscribing to
    // OnboardingProgressService.percentage$ keeps it live — every
    // `completeStep()` call anywhere in the app updates this immediately.
    this.subscriptions.push(
      this.onboardingProgress.percentage$.subscribe((percentage) => {
        this.progressValue = percentage;
      })
    );

    // Issue #537: header hat glow now tracks the per-step model instead of
    // the legacy onboardingv2_completed flag — subscribed (not read once)
    // so completing the 3rd required step drops the glow live, without a
    // reload.
    this.subscriptions.push(
      this.onboardingProgress.firstThreeComplete$.subscribe((firstThreeComplete) => {
        this.firstThreeComplete = firstThreeComplete;
      })
    );

    this.subscriptions.push(
      router.events.subscribe((val: any) => {
        // reset search query
        if (val instanceof NavigationEnd && val.url != "/advanced-search-result" && val.url == val.urlAfterRedirects) {
          // this.myControl.setValue("");
        }
        if (val?.snapshot?.queryParams.q) {
          this.myControl.setValue(val.snapshot.queryParams.q);
        }
      })
    );
  }
  // R20: replaces MatAutocompleteTrigger — the results panel is now a plain
  // div gated on this boolean instead of a CDK-overlay-backed trigger.
  panelOpen = false;

  // Combobox keyboard state (parity with mat-autocomplete's arrow-key
  // navigation, which R20's plain-div panel dropped). The options render
  // grouped, so navigation runs over a flattened index; per-group offsets map
  // (groupIndex, itemIndex) → flat index for the template's ids/highlight.
  highlightedIndex = -1;
  private groupOffsets: number[] = [];
  private flatCount = 0;
  private currentGroups: { type: string; items: any[] }[] = [];

  private setGroups(groups: { type: string; items: any[] }[] | null): void {
    this.currentGroups = groups ?? [];
    this.groupOffsets = [];
    let offset = 0;
    for (const group of this.currentGroups) {
      this.groupOffsets.push(offset);
      offset += group.items?.length ?? 0;
    }
    this.flatCount = offset;
    this.highlightedIndex = -1;
  }

  flatIndex(groupIndex: number, itemIndex: number): number {
    return (this.groupOffsets[groupIndex] ?? 0) + itemIndex;
  }

  private flatItem(index: number): any {
    for (let gi = 0; gi < this.currentGroups.length; gi++) {
      const items = this.currentGroups[gi].items ?? [];
      const offset = this.groupOffsets[gi];
      if (index < offset + items.length) {
        return items[index - offset];
      }
    }
    return null;
  }

  get activeOptionId(): string | null {
    return this.highlightedIndex >= 0 ? `global-search-option-${this.highlightedIndex}` : null;
  }

  private scrollHighlightedIntoView(): void {
    const id = this.activeOptionId;
    if (id) {
      document.getElementById(id)?.scrollIntoView({ block: "nearest" });
    }
  }

  async ngOnInit(): Promise<void> {
    this.checkIfIsOnboardingProgressTrainingUrl();
    // Issue #537: re-checked AFTER the training-url check above, which may
    // have opened the walk-me modal synchronously (setting onboardingActive
    // true) — the gate inside this call reads that flag fresh, so it
    // correctly no-ops rather than racing the modal.
    this.maybeShowOnboardingReentryTooltip();
    this.filteredOptions = this.myControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((val) => {
        // isLoading is flipped here rather than in a tap() before switchMap:
        // switchMap unsubscribes a still-in-flight inner BEFORE projecting the
        // new value, so the cancelled inner's finalize would otherwise clear a
        // flag the tap had just set.
        this.isLoading = true;
        return this.search(val).pipe(
          // H3: without this, one failed search request (e.g. a 401 during the
          // boot token-refresh race) errored the outer stream and killed the
          // suggestions panel for the rest of the session.
          catchError(() => of([])),
          finalize(() => (this.isLoading = false))
        );
      }),
      tap((groups: any) => this.setGroups(groups))
    );

    this.globalHookService.registerComponent("topBar", this);
  }

  clicked() {
    this.advancedSearch = false;
    this.isLoading = false;
    this.openPanel();
  }

  openPanel(): void {
    this.panelOpen = true;
  }

  closePanel(): void {
    this.panelOpen = false;
    this.highlightedIndex = -1;
  }

  onInputFocus(): void {
    this.openPanel();
  }

  // H3: the panel used to close on ANY blur (`setTimeout(closePanel, 150)`),
  // which mat-autocomplete never did — MatAutocompleteTrigger dismisses on an
  // outside CLICK (its document click/touch stream), not on the input losing
  // focus, so a programmatic `input.blur()` left OLD's panel open. That
  // difference is exactly what made the suggestions vanish from every NEW
  // capture: the harness blurs the active element while settling
  // (e2e/comparison/capture/stabilize.ts `settle()`), and 150ms later the panel
  // was `display: none` before the screenshot. Dismissal now mirrors Material:
  //   - outside mousedown  → close (below);
  //   - focusout with a REAL relatedTarget outside the component → close, so
  //     tabbing away still dismisses it;
  //   - focusout with no relatedTarget (programmatic blur) → keep it open.
  @HostListener("document:mousedown", ["$event"])
  onDocumentMouseDown(event: MouseEvent): void {
    if (!this.panelOpen) {
      return;
    }
    const target = event.target as Node | null;
    if (target && this.host.nativeElement.contains(target)) {
      return;
    }
    this.closePanel();
  }

  onInputFocusOut(event: FocusEvent): void {
    const next = event.relatedTarget as Node | null;
    if (!next || this.host.nativeElement.contains(next)) {
      return;
    }
    this.closePanel();
  }
  search(value: any): any {
    if (!value) {
      return of([]);
    }

    return this.dataService.searchTrack({ q: value }).pipe(map((tracks) => tracks.result.data));
  }

  displayFn(value: any): string {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.shortcut ?? value.name ?? '';
  }

  toggleAdvanced() {
    this.advancedSearch = true;
    this.openDialog();
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  openDialog() {
    this.closePanel();

    // VngDialogConfig has no `position` input (unlike MatDialogConfig) — the
    // sidebar-relative left offset is reproduced with global CSS on
    // `.advanced-search[--sidebar-open|--sidebar-closed] .vng-dialog-panel`
    // (see src/assets/styles/app.scss). panelClass carries the state as a
    // second class since the offset depends on whether the sidenav is open.
    const isSideMenuOpened = this.sharedData.getAttribute("sidePanelOpened");
    const sidebarClass = isSideMenuOpened == "true" ? "advanced-search--sidebar-open" : "advanced-search--sidebar-closed";

    this.currentDialog = this.dialog.open(AdvancedSearchDialogComponent, {
      width: "35%",
      panelClass: ["advanced-search", sidebarClass],
    });

    // VngDialogRef has no beforeClosed() (unlike MatDialogRef) — moved to
    // afterClosed(); the 30-150ms visual difference (backdrop/panel already
    // gone vs. about to close) is within tolerance (R6).
    this.currentDialog.afterClosed().subscribe((result) => {
      this.advancedSearch = false;
      this.isLoading = false;
      if (!result) {
        // Only clear on cancel; search path sets advancedSearchData before closing
        this.sharedData.setAttribute("advancedSearchData", null);
      }
      this.openPanel();
    });
  }

  goToAdvancedSearch() {
    const raw = this.myControl.value;
    const q: string = typeof raw === 'string' ? raw.trim() : (raw?.shortcut ?? raw?.name ?? '');
    if (!q) {
      return;
    }

    this.isLoading = true;
    const navigationExtras: NavigationExtras = {
      state: {
        searchValue: q,
      },
      queryParams: {
        q,
      },
    };
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate(["/advanced-search-result"], navigationExtras);
    });
  }

  keyDownFunction(event: KeyboardEvent) {
    const optionsVisible = this.panelOpen && !this.advancedSearch && this.flatCount > 0;

    switch (event.key) {
      case "ArrowDown":
        if (!this.panelOpen) {
          this.openPanel();
        }
        if (this.flatCount > 0) {
          event.preventDefault();
          this.highlightedIndex = (this.highlightedIndex + 1) % this.flatCount;
          this.scrollHighlightedIntoView();
        }
        break;

      case "ArrowUp":
        if (this.flatCount > 0) {
          event.preventDefault();
          this.highlightedIndex = this.highlightedIndex <= 0 ? this.flatCount - 1 : this.highlightedIndex - 1;
          this.scrollHighlightedIntoView();
        }
        break;

      case "Escape":
        this.closePanel();
        break;

      case "Enter":
        if (optionsVisible && this.highlightedIndex >= 0) {
          event.preventDefault();
          this.clickOption(this.flatItem(this.highlightedIndex));
          break;
        }
        // was: `$event.target.blur(); trigger.closePanel();` on the (removed)
        // mat-autocomplete's own (keydown.enter) — moved onto the real Enter
        // keystroke on the input itself (R20).
        this.closePanel();
        (event.target as HTMLInputElement)?.blur();
        this.goToAdvancedSearch();
        break;
    }
  }

  clickOption(item?: any) {
    this.closePanel();
    if (item?.url) {
      this.router.navigateByUrl(item.url);
      return;
    }
    if (item) {
      // Material's [value]="item" + [displayWith]="displayFn" used to write
      // the picked item's display text back into myControl automatically on
      // selection; replicate that explicitly now that the panel is plain
      // HTML (R20) so goToAdvancedSearch() reads the clicked item, not
      // whatever was still typed.
      this.myControl.setValue(this.displayFn(item));
    }
    this.goToAdvancedSearch();
  }

  showOnboarding() {
    this.globalHookService.components.global.startModal();
  }

  gotToOnboarding() {
    if (this.router.url !== "/flyboard?showonboardingprogresstraining=true") {
      this.router.navigate(["/flyboard"], { queryParams: { showonboardingprogresstraining: true } });
    } else {
      this.showOnboarding();
    }
  }

  /**
   * Issue #537: on a load where the hard-refresh bypass left the first
   * three required steps incomplete AND the walk-me modal isn't open,
   * anchors a tooltip to the header hat explaining how to reopen the
   * walkthrough. Reuses the showLearningResourcesTooltip() VngTourService
   * pattern below, anchored on the same "step19" hat element. Copy is a
   * first pass — flagged for a product tweak.
   *
   * QA F-1 (PR #540 review): the conditions above are only checked at
   * SCHEDULE time. The actual tourService.start() call is deferred 500ms
   * (matching showLearningResourcesTooltip()'s own pattern), and a lot can
   * happen in that window — most commonly the walk-me modal opening (a
   * fresh account auto-opens it independently of this component). Two
   * things make that dangerous together: (a) nothing was cancelling the
   * pending timer on teardown, so a torn-down tooltip could still render
   * on top of whatever opened meanwhile; (b) tourService.end() on a tour
   * that was never start()ed never fires end$, so the "this teardown isn't
   * a dismissal" flag never got reset, silently discarding the user's next
   * REAL dismissal. Fixed by: tracking the timer so teardown can cancel it
   * (reentryTooltipStartTimer), re-checking eligibility again right before
   * the deferred start() actually fires, and only doing the
   * flag-plus-tourService.end() dance in teardown when the tour has
   * genuinely started (reentryTooltipStarted) — see
   * teardownOnboardingReentryTooltip() below.
   */
  private maybeShowOnboardingReentryTooltip(): void {
    if (this.globalHookService.onboardingActive) {
      // Modal is already open (e.g. the training-url check above just
      // opened it) — nothing to reopen, so nothing to point at.
      return;
    }
    if (!this.onboardingProgress.shouldShowReentryTooltip) {
      return;
    }

    this.reentryTooltipActive = true;
    this.reentryTooltipStarted = false;
    this.tourService.initialize([
      {
        anchorId: "step19",
        title: "Continue Onboarding",
        // Suggested copy — flag for product to tweak.
        content: "Pick up your onboarding where you left off — click the hat to reopen it.",
        endBtnTitle: "Got it!",
      },
    ]);

    const endSub = this.tourService.end$.subscribe(() => {
      this.reentryTooltipActive = false;
      this.reentryTooltipStarted = false;
      if (!this.reentryTooltipTeardownProgrammatic) {
        // A real user dismissal (clicked "Got it!"/closed the popover), as
        // opposed to this component tearing itself down below.
        this.onboardingProgress.recordReentryTooltipDismissal();
      }
      this.reentryTooltipTeardownProgrammatic = false;
      endSub.unsubscribe();
      this.reentryTooltipEndSub = null;
    });
    this.reentryTooltipEndSub = endSub;
    this.subscriptions.push(endSub);

    this.reentryTooltipStartTimer = setTimeout(() => {
      this.reentryTooltipStartTimer = null;

      // QA F-1: re-check at FIRE time, not schedule time. Torn down while
      // pending (reentryTooltipActive already false) — nothing to start.
      if (!this.reentryTooltipActive) {
        return;
      }
      // Conditions flipped without an explicit teardown call reaching us
      // (e.g. some other path opened the modal) — belt-and-suspenders
      // clean up, same as a programmatic teardown, without ever rendering.
      if (this.globalHookService.onboardingActive || !this.onboardingProgress.shouldShowReentryTooltip) {
        this.reentryTooltipActive = false;
        this.reentryTooltipTeardownProgrammatic = false;
        this.reentryTooltipEndSub?.unsubscribe();
        this.reentryTooltipEndSub = null;
        return;
      }

      this.reentryTooltipStarted = true;
      this.tourService.start();
    }, 500);
  }

  /**
   * Issue #537: tears down the re-entry tooltip WITHOUT counting it as a
   * dismissal — called when the walk-me modal opens while the tooltip
   * happens to be showing (GlobalOverlayComponent.startModal(), the single
   * choke point every "open the modal" path funnels through) and from
   * showLearningResourcesTooltip() below, so the two hat tours never
   * overlap. No-op if the re-entry tooltip isn't the one currently active.
   *
   * QA F-1: always cancels the pending start() timer first — that alone is
   * what stops a torn-down tooltip from rendering later on top of whatever
   * just opened. If the tooltip hadn't actually started yet, tourService.end()
   * is skipped entirely (it would no-op and never fire end$ anyway) and the
   * end$ subscription is unsubscribed directly instead, so this can never
   * leave reentryTooltipTeardownProgrammatic stuck true for a later, genuine
   * dismissal to be silently discarded against.
   */
  teardownOnboardingReentryTooltip(): void {
    if (!this.reentryTooltipActive) {
      return;
    }
    if (this.reentryTooltipStartTimer !== null) {
      clearTimeout(this.reentryTooltipStartTimer);
      this.reentryTooltipStartTimer = null;
    }
    if (!this.reentryTooltipStarted) {
      this.reentryTooltipActive = false;
      this.reentryTooltipEndSub?.unsubscribe();
      this.reentryTooltipEndSub = null;
      return;
    }
    this.reentryTooltipTeardownProgrammatic = true;
    this.tourService.end();
  }

  showLearningResourcesTooltip() {
    // Issue #537: only one hat tour at a time — if the re-entry tooltip
    // happens to still be showing when the full walkthrough completes,
    // tear it down (not a dismissal) before this one takes the anchor.
    this.teardownOnboardingReentryTooltip();

    const user = this.authService.userDetails.user_details;

    if (user.tooltip_learning_resources_showed) {
      return;
    }

    this.tourService.initialize([
      {
        anchorId: "step19",
        content:
          "Click here to resume your onboarding anytime. There are more learning videos to help you get more useful information about all the FlyMSG features.",
        title: "Learning Resources",
        nextBtnTitle: "Got it!",
      },
      {
        anchorId: "stepFake",
        content: "This is a fake step",
      },
    ]);

    this.tourService.stepShow$.subscribe((step) => {
      if (step.anchorId === "stepFake") {
        const user = this.authService.userDetails.user_details;
        lastValueFrom(
          this.authService.patchOnboarding(user.id, user.onboardingv2_step, user.onboardingv2_step, true, false)
        );
        this.tourService.end();
      }
    });

    setTimeout(() => {
      this.tourService.start();
    }, 500);
  }

  // Centralized in OnboardingProgressService (issue #523) — these getters
  // are now thin passthroughs instead of a 3rd copy of the same logic.
  get maxStep() {
    return this.onboardingProgress.maxStep;
  }

  get showFlyLearning() {
    return this.onboardingProgress.showFlyLearning;
  }

  checkIfIsOnboardingProgressTrainingUrl() {
    if (this.router.url === "/onboardingprogress_training") {
      this.showOnboarding();
      return;
    }

    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        if (params?.showonboardingprogresstraining === "true") {
          this.showOnboarding();
        }
      })
    );
  }

  afterModalIsClosed<T>(modal: VngDialogRef<T>) {
    modal.afterClosed().subscribe({
      next: (data) => {
        if (data?.action === "retake_onboarding") {
          return;
        }
        if (this.currentUrl === "/flyboard?showonboardingprogresstraining=true") {
          this.location.replaceState("flyboard");
          return;
        }
        this.location.replaceState(this.currentUrl || "flyboard");
      },
    });
  }

  ngOnDestroy(): void {
    // QA F-1 (issue #537): a pending re-entry-tooltip start() timer must not
    // outlive this component — without this, a torn-down-by-navigation
    // header could still fire start() against a destroyed component's
    // tourService state.
    if (this.reentryTooltipStartTimer !== null) {
      clearTimeout(this.reentryTooltipStartTimer);
      this.reentryTooltipStartTimer = null;
    }
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
